// app/page.tsx
'use client';

import { useRouter } from 'next/navigation';
import React, { Suspense, useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { generateRoomId } from '@/lib/client-utils';
import { VideoIcon } from '@/components/meetx/Icons';
import { HomeIcon } from '@/components/dashboard/Icons';
import { useAuth } from '@/lib/context/AuthContext';
import toast from 'react-hot-toast';
import styles from './meetx-home.module.css';

function HomeContent() {
  const router = useRouter();
  const { user, loading } = useAuth();
  const [joinCode, setJoinCode] = useState('');

  function startMeeting() {
    if (!loading && !user) {
      toast.error('Anda belum login. Silakan login terlebih dahulu.');
      setTimeout(() => {
        router.push('/login');
      }, 1500);
      return;
    }
    router.push(`/rooms/${generateRoomId()}?create=true`);
  }

  function joinMeeting() {
    const code = joinCode.trim();
    if (!code) return;
    const roomName = code.replace(/^.*\/rooms\//, '').replace(/^.*\/join\//, '');
    router.push(`/rooms/${roomName}`);
  }

  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <header className={styles.header}>
          <div className={styles.logo}>
            <Image src="/images/logo.png" alt="MeetX Logo" width={140} height={40} className={styles.logoImg} />
          </div>
          <div className={styles.headerActions}>
            {!loading && user ? (
              <Link href="/home" className={styles.viewRecordingsBtn}>
                <HomeIcon size={18} /> Dashboard
              </Link>
            ) : (
              <Link href="/login" className={styles.viewRecordingsBtn}>
                <HomeIcon size={18} /> Login
              </Link>
            )}
          </div>
        </header>

        <div className={styles.heroContent}>
          <section className={styles.textSection}>
            <h1 className={styles.headline}>
              Secure Active, <br />Connect.
            </h1>

            <div className={styles.actionCard}>
              <button className={styles.newMeetingBtn} onClick={startMeeting}>
                <VideoIcon size={24} /> New Meeting
              </button>

              <div className={styles.divider}>
                <span>or join with a code</span>
              </div>

              <div className={styles.inputGroup}>
                <input
                  className={styles.joinInput}
                  placeholder="Enter a room code or link..."
                  value={joinCode}
                  onChange={(e) => setJoinCode(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && joinMeeting()}
                />
                <button className={styles.joinBtn} onClick={joinMeeting}>
                  Join
                </button>
              </div>
            </div>
          </section>

          <section className={styles.illustrationSection}>
            <div className={styles.heroImageWrapper}>
              <Image
                src="/images/hero_lineart.png"
                alt="MeetX Meeting Preview"
                width={600}
                height={400}
                className={styles.heroImage}
                priority
              />
            </div>
          </section>
        </div>

        <footer className={styles.footer}>
          Powered by <a href="https://eprisi.com/" target="_blank" rel="noopener noreferrer" className={styles.footerLink}>PT. Epsilon Prisma Sinergi</a>
        </footer>
      </div>
    </main>
  );
}

import { AuthProvider } from '@/lib/context/AuthContext';

export default function Page() {
  return (
    <AuthProvider>
      <Suspense>
        <HomeContent />
      </Suspense>
    </AuthProvider>
  );
}
